import Abstract from '../../framework/Abstract';

import '../F1-account-information/F1-account-information.scss';

class F1AccountInformation extends Abstract {
	init() {
		// console.log('F1.1 HTML Account Information Mounted', this.config);
	}
}

export default F1AccountInformation;
